import { Dialog, DialogContent, DialogContentText } from '@material-ui/core';
import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';

const ModalProfilCandidat = ({ children, onCancel, open }) => {
  const { css } = useStyles();

  return (
    <Dialog
      BackdropProps={{
        style: {
          backgroundColor: 'rgba(0, 45, 117, 0.6)',
        },
      }}
      classes={{
        paperScrollPaper: css({
          width: '100%',
          maxWidth: 500,
          borderRadius: 20,
        }),
      }}
      onClose={onCancel}
      open={open}
    >
      <DialogContent>
        <DialogContentText>{children}</DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

ModalProfilCandidat.propTypes = {
  open: PropTypes.bool,
  children: PropTypes.node,
  onCancel: PropTypes.func,
};

export default ModalProfilCandidat;
